
/*
This abstract class is a wrapper around all things that we could store in the document.

Since the stored items get written out to the document's custom.xml, we should ensure that any new
settings added here go through Word's file format update process.
*/

import { ErrorStringFromException } from "../../utils/utils";
import { DocumentStorageError, DocumentStorageErrors } from "./DocumentStorageErrors";
import { HostAppSettingName, HostAppSettings } from "./HostAppSettings";

/*
VSO:3702626 tracks following up with Word's file format team for this.
*/

export abstract class DocumentStorage {

  abstract WriteTranscribeContentToClient(content: string): Promise<void>;
  abstract DeleteTranscribeContentFromClient(): Promise<void>;

  GetStoredTranscription(): any {
    let storedTranscriptionString : string = "";
    try {
      storedTranscriptionString = HostAppSettings.GetSettingAsString(HostAppSettingName.StoredTranscription);
      const storedTranscriptionJson = JSON.parse(storedTranscriptionString);
      return storedTranscriptionJson;
    } catch (e) {

      // Adding suffix error message to provide more information about 
      // transcription string property
      let suffixErrorMessage = "";
      if(storedTranscriptionString === undefined){
        suffixErrorMessage = ", Stored transcription string is Undefined";
      } else {
        suffixErrorMessage = ", Stored transcription string has length : " + storedTranscriptionString.length;
      }
      throw new DocumentStorageError(DocumentStorageErrors.CorruptTranscriptSource, ErrorStringFromException(e) + 
                  suffixErrorMessage);
    }
  }

}